{
  "process-container": {
    "text": {
      "back-to-home": "Back to home page",
      "page-loading": "Page is loading"
    }
  }
}
